import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ClassifiedItemTypes } from "../../../type/classified-item-type";

@Component({
  selector: "ngx-new-product-define-column",
  template: `
    <ngx-tag 
      *ngIf="type == 'NEW'"
      [value]="!data.productInfo ? '지정필요' : '지정완료'"
      [status]="!data.productInfo ? 'warning' : 'primary'">
    </ngx-tag>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class NewProductDefineComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;
  public data: any;
  public type: any;

  constructor() {}

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.data = params.data;
    this.type = ClassifiedItemTypes[params.data.type].value;
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.type = this.params.data.type;
  }

  ngOnInit() { }

}
